import { render } from "./EditMenuPage.vue?vue&type=template&id=3582c295&ts=true"
import script from "./EditMenuPage.vue?vue&type=script&lang=ts"
export * from "./EditMenuPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__